import Cookies from "js-cookie";

export type ConsentPreferences = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
};

export const COOKIE_CONSENT_KEY = "ns_cookie_consent";

const COOKIE_OPTIONS = {
  expires: 180, // roughly 6 months
  sameSite: "lax" as const,
};

export const defaultConsent: ConsentPreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};

const normalizePreferences = (
  prefs?: Partial<ConsentPreferences>
): ConsentPreferences => ({
  ...defaultConsent,
  ...prefs,
  necessary: true, // always enforced
});

export const saveConsent = (prefs: Partial<ConsentPreferences>) => {
  const normalized = {
    ...normalizePreferences(prefs),
    updatedAt: new Date().toISOString(),
  };

  Cookies.set(COOKIE_CONSENT_KEY, JSON.stringify(normalized), COOKIE_OPTIONS);
  return normalized;
};

export const loadConsent = (): ConsentPreferences => {
  const raw = Cookies.get(COOKIE_CONSENT_KEY);
  if (!raw) return defaultConsent;

  try {
    const parsed = JSON.parse(raw) as Partial<ConsentPreferences>;
    return normalizePreferences(parsed);
  } catch (error) {
    console.error("[cookieConsent] Failed to parse consent cookie", error);
    return defaultConsent;
  }
};

export const hasConsentDecision = () => !!Cookies.get(COOKIE_CONSENT_KEY);
